module.exports = __webpack_public_path__ + "media/images/bikes-1236f713.jpg";